<mat-list>
  @for (message of messages; track message) {
    <mat-list-item>{{message}}</mat-list-item>
  }
</mat-list>